/**
 * [结算模式]
 * @author: Fu Xiaochun
 * @date: 2022-05-30 
 */


import React, { useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import styles from './index.module.scss';
import { InputNumber, message, Radio, } from 'antd';
import PropTypes from 'prop-types';

function SettleModel(props, ref) {

    // 结算模式
    const [settleModel, setSettleModel] = useState('FULL');  // 结算模式
    const [platRatio, setPlatRatio] = useState();  // 平台比例
    const [operationCenterRatio, setOperationCenterRatio] = useState();  // 市级运营中心比例
    const [areaCompanyRatio, setAreaCompanyRatio] = useState();  // 县级运营中心比例
    const [riderRatio, setRiderRatio] = useState();  // 骑手比例
    const [companyRatio, setCompanyRatio] = useState();  // 小运力公司比例

    useEffect(() => {
        if (props.detail.id) {
            initData();
        }
    }, [props.detail]);

    const initData = () => {
        let detail = props.detail;
        setSettleModel(detail.settleType || 'FULL');
        setAreaCompanyRatio(detail.areaCompanyRatio);
        setCompanyRatio(detail.smallTransportRatio);
        setRiderRatio(detail.riderRatio);
    };

    useImperativeHandle(ref, () => ({
        getState: () => {
            return {
                settleModel,
                platRatio,
                operationCenterRatio,
                areaCompanyRatio,
                riderRatio,
                companyRatio
            };
        }
    }));

    return (
        <div className={styles.settleModel}>
            <div className={styles.item}>
                <div className={styles.label}>结算模式：</div>
                <div className={styles.val}>
                    <Radio.Group onChange={e => { setSettleModel(e.target.value); }} value={settleModel}>
                        <Radio value="FULL">全额结算</Radio>
                        <Radio value="REVENUE_ONLY">仅收益结算</Radio>
                    </Radio.Group>
                    <div className={styles.extTxt}>
                        {settleModel == 'FULL' && <p>配送单骑手的收益和站点的收益全部结算给站点</p>}
                        {settleModel == 'REVENUE_ONLY' && <p>配送单骑手的收益结算给骑手，站点仅结算自身收益部分</p>}
                    </div>
                </div>
            </div>
            {/* <div className={styles.item}>
                <div className={styles.label}>平台服务费：</div>
                <div className={styles.val}>
                    <InputNumber addonAfter="%" className={styles.txt} value={platRatio} precision={2} min={0} max={100} placeholder="支持小数点后两位" onChange={e => { setPlatRatio(e); }} />
                    <div className={styles.extTxt}>不设置或设置为零则表示不收取服务费，则运营中心分润为0</div>
                </div>
            </div>
            <div className={styles.item}>
                <div className={styles.label}>市级运营中心：</div>
                <div className={styles.val}>
                    <InputNumber addonAfter="%" className={styles.txt} value={operationCenterRatio} precision={2} min={0} max={100} placeholder="支持小数点后两位" onChange={e => { setOperationCenterRatio(e); }} />
                </div>
            </div> */}
            {settleModel == 'FULL'
                ? <div className={styles.item}>
                    <div className={styles.label}>运营公司：</div>
                    <div className={styles.val}>
                        <InputNumber addonAfter="%" className={styles.txt} value={areaCompanyRatio} precision={2} min={0} max={100} placeholder="支持小数点后两位" onChange={e => { setAreaCompanyRatio(e); }} />
                        <div className={styles.extTxt}>运营公司分润 = (配送费(不含小费) - 平台服务费)  * 呈现比例</div>
                    </div>
                </div>
                : null}

            {settleModel == 'REVENUE_ONLY' ? (
                <div className={styles.item}>
                    <div className={styles.label}>站点：</div>
                    <div className={styles.val}>
                        <InputNumber addonAfter="%" className={styles.txt} value={companyRatio} precision={2} min={0} max={100} placeholder="支持小数点后两位" onChange={e => { setCompanyRatio(e); }} />
                        <div className={styles.extTxt}>站点分润 = (配送费(不含小费) - 平台服务费) * 呈现比例</div>
                    </div>
                </div>
            ) : null}
            <div className={styles.item}>
                <div className={styles.label}>骑手配送费：</div>
                <div className={styles.val}>
                    <InputNumber addonAfter="%" className={styles.txt} value={riderRatio} precision={2} min={0} max={100} placeholder="支持小数点后两位" onChange={e => { setRiderRatio(e); }} />
                    {settleModel == 'FULL'
                        ? <div className={styles.extTxt}>骑手端呈现配送费 = (配送费-平台服务费) x 呈现比例 + 小费，仅作呈现不实际结算</div>
                        : <div className={styles.extTxt}> 骑手配送费 = (配送费(不含小费) - 平台服务费) x 呈现比例 + 小费，直接结算给骑手</div>}

                </div>
            </div>
        </div>
    );
}

const RefSettleModel = forwardRef(SettleModel);

SettleModel.propTypes = {
    detail: PropTypes.object,
};

SettleModel.defaultProps = {
    detail: {}
};


export default RefSettleModel;